import {
	NEWS_GET,
	POSITIONS_ALL_GET,
	POSITIONS_INFO_SET,
	POSITIONS_TAB_SET,
	POSITIONS_SEARCH_STRING,
	POSITIONS_ALL_SET,
	UPDATE_TRADES_DATA,
	POSITIONS_DEFAULT_SET,
	POSITIONS_MARGIN_CALL_SENT,
	POSITIONS_FOREX_REFRESH_SET, TRADES_TIMERS_SET
} from './actions'
import { LOGOUT } from '../user/actions'


const initialState = {
	closeReason: 0,
	closedPositions: [],
	forexRefreshTrades: {},
	marginCallSent: Math.floor(Date.now() / 1000)-5,
	newsArr: [],
	openPositions: {},
	pendingPositions: [],
	positionInfo: {},
	positionSearchString: '',
	positionsAll: {},
	positionsDefault: {},
	positionsTab: '',
	totalAmountTradeOpenPosition: 0,
	totalPnl: 0,
	tradesTimers: {}
}

export default (state = initialState, action) => {
	switch (action.type) {
	case LOGOUT: {
		return {
			...initialState
		}
	}
	case POSITIONS_ALL_GET: {
		let totalAmountTradeOpen = 0
		let obj = action.payload.reduce((result, trade) => {
			let key = ''
			if (trade.status === 'open') {
				totalAmountTradeOpen = +totalAmountTradeOpen + +trade.amount
				key = 'open'
			} else if (trade.status.indexOf('pending') >= 0) {
				key = 'pending'
			}  else if (trade.status !== 'open' &&  trade.status.indexOf('pending') < 0) {
				key = 'close'
			}
			if (!result[key]) result[key] = {}
			result[key][trade.id] = trade
			return result;
		}, {})
		return {
			...state,
			positionsAll: {...state.positionsAll, ...obj},
			totalAmountTradeOpenPosition: totalAmountTradeOpen
		}
	}
	case POSITIONS_ALL_SET: {
		return {
			...state,
			positionsAll: action.payload.formatted,
			totalAmountTradeOpenPosition: action.payload.totalAmountTradeOpen
		}
	}
	case POSITIONS_MARGIN_CALL_SENT: {
		return {
			...state,
			marginCallSent: action.payload
		}
	}
	case POSITIONS_FOREX_REFRESH_SET: {
		const forexRefreshTrades = {...state.forexRefreshTrades}
		forexRefreshTrades[action.payload.tradeId] = action.payload.value
		return {
			...state,
			forexRefreshTrades: {...state.forexRefreshTrades, ...forexRefreshTrades}
		}
	}
	case TRADES_TIMERS_SET: {
		const tradesTimers = {...state.tradesTimers}
		tradesTimers[action.payload.tradeId] = action.payload.value
		return {
			...state,
			tradesTimers: {...state.tradesTimers, ...tradesTimers}
		}
	}
	case POSITIONS_DEFAULT_SET: {
		return {
			...state,
			positionsDefault: action.payload
		}
	}
	case UPDATE_TRADES_DATA: {
		return {
			...state,
			positionsAll: { ...state.positionsAll, ...action.payload }
		}
	}

	case NEWS_GET: {
		return {
			...state,
			newsArr: action.payload
		}
	}
	case POSITIONS_TAB_SET: {
		return {
			...state,
			positionsTab: action.payload
		}
	}
	case POSITIONS_INFO_SET: {
		return {
			...state,
			positionInfo: action.payload
		}
	}

	case POSITIONS_SEARCH_STRING: {
		return {
			...state,
			positionSearchString: action.payload
		}
	}

	default: {
		return state
	}
	}
}


